import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope, faClock } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faYoutube, faTwitter } from '@fortawesome/free-brands-svg-icons';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="footer-brand-header">
              <img src="/images/logo.png" alt="Logo STIKES Baramuli" className="footer-logo" />
              <h3>STIKES Baramuli</h3>
            </div>
            <p>
              Sekolah Tinggi Ilmu Kesehatan Baramuli adalah institusi pendidikan 
              tinggi kesehatan yang berkomitmen menghasilkan lulusan profesional, 
              kompeten, dan beretika di bidang kesehatan.
            </p>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4>Tautan Cepat</h4>
            <ul>
              <li><Link to="/">Beranda</Link></li>
              <li><Link to="/profil">Profil</Link></li>
              <li><Link to="/program-studi">Program Studi</Link></li>
              <li><Link to="/pendaftaran">Pendaftaran</Link></li>
              <li><Link to="/layanan">Layanan</Link></li>
            </ul>
          </div>

          {/* Program Studi */}
          <div className="footer-links">
            <h4>Program Studi</h4>
            <ul>
              <li><Link to="/program-studi/s1-keperawatan">S1 Keperawatan</Link></li>
              <li><Link to="/program-studi/profesi-ners">Profesi Ners</Link></li>
              <li><Link to="/program-studi/s1-kesmas">S1 Kesehatan Masyarakat</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-links">
            <h4>Kontak</h4>
            <div className="footer-contact-item">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <span>Jl. Poros Pinrang-Polman KM.03, Kec. Paleteang, Kab. Pinrang</span>
            </div>
            <div className="footer-contact-item">
              <FontAwesomeIcon icon={faPhone} />
              <span>0858-2487-1455</span>
            </div>
            <div className="footer-contact-item">
              <FontAwesomeIcon icon={faEnvelope} />
              <span>info@stikesbaramuli.ac.id</span>
            </div>
            <div className="footer-contact-item">
              <FontAwesomeIcon icon={faClock} />
              <span>Senin - Jumat: 08.00 - 16.00 WITA</span>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>&copy; {currentYear} STIKES Baramuli. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Kebijakan Privasi</Link>
            <Link to="/terms">Syarat & Ketentuan</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
